class ExpandAllButton
  constructor: ->
    $(document).on 'click', '[data-expand-all]', (e) ->
      el = $(e.currentTarget)
      showElements(el)
      replace(el)
      triggerEvents(el)

  @create: (options) ->
    ###
    Required attributes:
      * data-target
    ###
    $('<button>')
      .attr('data-expand-all', true)
      .text('Expand All')
      .addClass('btn btn-sm btn-success')
      .data('target', options.target)

  replace = (el) ->
    target = $(el.data('target'))
    el.replaceWith CollapseAllButton.create(target: target)

  showElements = (el) ->
    target = $(el.data('target'))
    target.find('[data-toggle="collapse"]:contains("Expand")').click()

  triggerEvents = (el) ->
    $(document).trigger
      type: 'collapse:expanded'
      element: $(el.data('target'))

global.ExpandAllButton = ExpandAllButton

export default ExpandAllButton